import { OptionCl } from "../../../components/select-cl"
import { DEPO_COUNTRY_DOMAIN } from "../../../domains/depository/country/service"
import { DEPO_CODE_DOMAIN } from "../../../domains/depository/code/service"
import { DEPO_CITY_DOMAIN } from "../../../domains/depository/city/service"
import { DEPO_NAME_DOMAIN } from "../../../domains/depository/name/service"
import { DEPO_TYPE_DOMAIN } from "../../../domains/depository/type/service"

export type DepositoryCriteriaState = {
    allDomainsLoaded: boolean,
    error?: string,
    countries?: OptionCl[] ,
    cities? : OptionCl[],
    depoCodes?: OptionCl[],
    depoNames?: OptionCl[],
    depoTypes?: OptionCl[]
}

export  type DepositoryCriteriaAction =
    {
        type: "DepositoryCriteria/DOMAINLOADED",
        payload: OptionCl[], 
        domain: string
    } | {
        type: "DepositoryCriteria/FETCHERROR",
        payload: string 
    }
  
const initialState: DepositoryCriteriaState = { allDomainsLoaded: false }

const getAllDomainsLoaded = ( state : DepositoryCriteriaState ) : boolean => {
        // console.log( "CCb criteria reducer.ts in getAllDomainsLoaded "  + JSON.stringify(state) + " tms:" + Date.now() )
return (typeof state.cities !== "undefined") && (state.cities !== null ) && 
       (typeof state.depoCodes !== "undefined") && (state.depoCodes !== null ) && 
       (typeof state.depoNames !== "undefined") && (state.depoNames !== null ) && 
       (typeof state.depoTypes !== "undefined") && (state.depoTypes !== null ) && 
       (typeof state.countries !== "undefined") && (state.countries !== null ) 
    }

export const depoCriteriaReducer = (
        state: DepositoryCriteriaState = initialState,
        action: DepositoryCriteriaAction 
    ) => {
        switch (action.type) {
            case "DepositoryCriteria/DOMAINLOADED":
                //console.log("Ccb Criteria Reducer.ts state" + JSON.stringify(state) + " tms:" + Date.now())
                //console.log("Ccb Criteria Reducer.ts received action" + JSON.stringify(action) + " tms:" + Date.now())
                if ( action.domain === DEPO_COUNTRY_DOMAIN) {  
                    const newState = { ...state, countries: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === DEPO_CODE_DOMAIN ) {
                    const newState = { ...state, depoCodes: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === DEPO_CITY_DOMAIN) {
                    const newState = { ...state, cities: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === DEPO_NAME_DOMAIN ) {
                    const newState = { ...state, depoNames: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else if ( action.domain === DEPO_TYPE_DOMAIN ) {
                    const newState = { ...state, depoTypes: action.payload };
                    newState.allDomainsLoaded = getAllDomainsLoaded( newState )
                    return newState;
                } else {
                    console.warn("Ccb Criteria reducer.ts: Unrecognized domain [" + action.domain + "]")
                    return state;
                }
                //return { ...state, countries: action.payload, allDomainsLoaded: true }
            case "DepositoryCriteria/FETCHERROR" :    
                return {
                    ...state,
                    allDomainsLoaded: false,
                    error: action.payload
                  };
            default: return state;
        }
    }
    